import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../../ui/button';
import { WidgetEmpty } from '../WidgetCard';
import {
  UserPlus, ClipboardList, Radio, FileText, ClipboardCheck,
  Car, Gift, Building2, Megaphone, Plus,
} from 'lucide-react';

const ICONS = {
  'user-plus': UserPlus, 'clipboard-list': ClipboardList, radio: Radio,
  'file-text': FileText, 'clipboard-check': ClipboardCheck, car: Car,
  gift: Gift, building: Building2, megaphone: Megaphone,
};

export const QuickActionsWidget = ({ data }) => {
  const navigate = useNavigate();
  const items = data?.items || [];

  if (!items.length) {
    return <WidgetEmpty testId="quick-actions-empty">
      You don&apos;t have permission to create anything yet.
    </WidgetEmpty>;
  }

  return (
    <div className="flex flex-wrap gap-2" data-testid="quick-actions-list">
      {items.map((a) => {
        const Icon = ICONS[a.icon] || Plus;
        return (
          <Button key={a.to + a.label} variant="outline" size="sm"
            className="rounded-full hover:border-[hsl(var(--brand-accent))]
              hover:text-[hsl(var(--brand-accent))] transition-colors duration-150"
            onClick={() => navigate(a.to)}
            data-testid={`quick-action-${a.label.toLowerCase().replace(/\s+/g, '-')}`}>
            <Icon className="w-4 h-4 mr-1.5" />{a.label}
          </Button>
        );
      })}
    </div>
  );
};

export default QuickActionsWidget;
